__turbopack_context__.v({
  "enhet": "EnheterMedUnderenheter-module__UBTYiG__enhet",
  "overflow-visible": "EnheterMedUnderenheter-module__UBTYiG__overflow-visible",
  "underenheter": "EnheterMedUnderenheter-module__UBTYiG__underenheter",
  "underenheterWrapper": "EnheterMedUnderenheter-module__UBTYiG__underenheterWrapper",
});
